import routes from './routes';
import endpoints from './endpoints';
import roles from './roles';
import locales from './locales';
import sexList from './sexList';

export default Object.freeze({
  routes,
  endpoints,
  roles,
  locales,
  sexList
});